import axios from "axios";

export default axios.create({
  baseURL: "https://kmb9ui6kvi.execute-api.us-west-1.amazonaws.com/dev",
  headers: {
    "Content-type": "application/json"
  }
});